import React, { Fragment } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import ExportTableExcel from 'components/Tvendo/Common/ExportTable';
import { styleTable, tableHover, bgBlue, bgDarkGreen } from '../../../Tableconstants/tableConstans';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  },
  table: tableHover
});

export default function Payment() {
  const classes = useStyles();
  return (
    <Fragment>
      <CardBody>
        <div style={{ overflow: 'auto' }}>
          <table
            id="table-rewards"
            border="1"
            width="100%"
            cellPadding="2"
            cellSpacing="0"
            style={{ ...styleTable, minWidth: '1750px' }}
            className={classes.table}
          >
            <thead>
              <tr>
                <th rowSpan="2" style={bgBlue}>
                  Nro
                </th>
                <th style={bgBlue}></th>
                <th colSpan="6" style={bgBlue}>
                  BENEFICIARIO (EMPLEADO)
                </th>
                <th rowSpan="2" style={bgBlue}>
                  MONTO A PAGAR
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  CIUDAD
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  CLIENTE
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  SUP. SOFTYS
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  DIRECCION
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  DNI
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  C/S TARJETA
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  OBSERVACIONES
                </th>
                <th rowSpan="2" style={bgDarkGreen}>
                  CONSULTA EsSalud
                </th>
              </tr>
              <tr>
                <th style={bgBlue}>Canal</th>
                <th style={bgBlue}>DNI / CE</th>
                <th style={bgBlue}></th>
                <th style={bgBlue}></th>
                <th style={bgBlue}>APELLIDO PATERNO</th>
                <th style={bgBlue}>APELLIDO MATERNO</th>
                <th style={bgBlue}>NOMBRE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Mayorista</td>
                <td>80465473</td>
                <td>47 - MANUYAMA MOZOMBITE JUAN PABLO</td>
                <td>560</td>
                <td>MANUYAMA</td>
                <td>MOZOMBITE</td>
                <td>JUAN PABLO</td>
                <td>560</td>
                <td>Chincha</td>
                <td>JRC DISTRIBUIDOR</td>
                <td>Ernesto Gallo</td>
                <td>CALLE 09 D EOCTUBRE 659 LA TINGUIÑA</td>
                <td></td>
                <td>Con Tarjeta</td>
                <td></td>
                <td>OK</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Mayorista</td>
                <td>80465473</td>
                <td>47 - MANUYAMA MOZOMBITE JUAN PABLO</td>
                <td>560</td>
                <td>MANUYAMA</td>
                <td>MOZOMBITE</td>
                <td>JUAN PABLO</td>
                <td>560</td>
                <td>Chincha</td>
                <td>JRC DISTRIBUIDOR</td>
                <td>Ernesto Gallo</td>
                <td>CALLE 09 D EOCTUBRE 659 LA TINGUIÑA</td>
                <td></td>
                <td>Con Tarjeta</td>
                <td></td>
                <td>OK</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Mayorista</td>
                <td>80465473</td>
                <td>47 - MANUYAMA MOZOMBITE JUAN PABLO</td>
                <td>560</td>
                <td>MANUYAMA</td>
                <td>MOZOMBITE</td>
                <td>JUAN PABLO</td>
                <td>560</td>
                <td>Chincha</td>
                <td>JRC DISTRIBUIDOR</td>
                <td>Ernesto Gallo</td>
                <td>CALLE 09 D EOCTUBRE 659 LA TINGUIÑA</td>
                <td></td>
                <td>Con Tarjeta</td>
                <td></td>
                <td>OK</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Mayorista</td>
                <td>80465473</td>
                <td>47 - MANUYAMA MOZOMBITE JUAN PABLO</td>
                <td>560</td>
                <td>MANUYAMA</td>
                <td>MOZOMBITE</td>
                <td>JUAN PABLO</td>
                <td>560</td>
                <td>Chincha</td>
                <td>JRC DISTRIBUIDOR</td>
                <td>Ernesto Gallo</td>
                <td>CALLE 09 D EOCTUBRE 659 LA TINGUIÑA</td>
                <td></td>
                <td>Con Tarjeta</td>
                <td></td>
                <td>OK</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Mayorista</td>
                <td>80465473</td>
                <td>47 - MANUYAMA MOZOMBITE JUAN PABLO</td>
                <td>560</td>
                <td>MANUYAMA</td>
                <td>MOZOMBITE</td>
                <td>JUAN PABLO</td>
                <td>560</td>
                <td>Chincha</td>
                <td>JRC DISTRIBUIDOR</td>
                <td>Ernesto Gallo</td>
                <td>CALLE 09 D EOCTUBRE 659 LA TINGUIÑA</td>
                <td></td>
                <td>Con Tarjeta</td>
                <td></td>
                <td>OK</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardBody>
      <CardFooter>
        <ExportTableExcel nameFile="recompenza" idTable="table-rewards" />
      </CardFooter>
    </Fragment>
  );
}
